module.exports = __webpack_public_path__ + "img/ImageHolder_dark.f94a0834.png";